
//import useState hook to create menu collapse state
import React, { useState } from "react";

//import react pro sidebar components
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
//import icons from react icons
import { FiLogOut } from "react-icons/fi";
import { IoAppsSharp } from "react-icons/io5";
import { LuText } from "react-icons/lu";
import { RiUserSettingsFill } from "react-icons/ri";
import { IoIosSettings } from "react-icons/io";
import { FaFile } from "react-icons/fa";
import { IoNotificationsCircleSharp } from "react-icons/io5";
import { RiAccountCircleFill } from "react-icons/ri";


//import sidebar css from react-pro-sidebar module and our custom css 
import "react-pro-sidebar/dist/css/styles.css";
import "./Header.css";


const Header = () => {

  //create initial menuCollapse state using useState hook
  const [menuCollapse, setMenuCollapse] = useState(false)

  //create a custom function that will change menucollapse state from false to true and true to false
  const menuIconClick = () => {
    //condition checking to change state from true to false and vice versa
    menuCollapse ? setMenuCollapse(false) : setMenuCollapse(true);
  };

  return (
    <>
      {/* <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed">
          <div className="logotext">
            <LuText className="hamberger" />
          </div>
          <div className="rightmenu">
            <IoNotificationsCircleSharp  />
            <RiAccountCircleFill  />
          </div>
        </AppBar>
      </Box>
      <div id="header">
        <ProSidebar collapsed={!menuCollapse}>

          <SidebarContent>
            <Menu iconShape="square">
              <MenuItem icon={<IoAppsSharp />}>
                Home
              </MenuItem>
              <MenuItem icon={<RiUserSettingsFill />}>User Setting</MenuItem>
              <MenuItem
                active={true}
                icon={<IoIosSettings className="actimenu" />
                }>Setting</MenuItem>
              <MenuItem icon={<FaFile />}>File</MenuItem>
            </Menu>
          </SidebarContent>
        </ProSidebar>
      </div> */}
    </>
  );
};

export default Header;